import { AnyAction } from 'redux';
import produce from 'immer';
import {
  VISITOR_REGISTER_CONFIRM_DISPATCH,
  VISITOR_REGISTER_CONFIRM_DISPATCH_INIT,
  POST_VISITOR_REGISTER_REQUEST,
  POST_VISITOR_REGISTER_SUCCESS,
  POST_VISITOR_REGISTER_FAILURE,
  POST_VISITOR_REGISTER_INITIAL,
  GET_VISITOR_RESERVATION_CHECK_REQUEST,
  GET_VISITOR_RESERVATION_CHECK_SUCCESS,
  GET_VISITOR_RESERVATION_CHECK_FAILURE,
  GET_VISITOR_RESERVATION_CHECK_INITIAL,
  VISITOR_COMPLETE_DISPATCH,
  VISITOR_COMPLETE_DISPATCH_INIT,
} from '../../actions';

export type VisitorInfo = {
  contentsId: number;
  eqsId: number;
  contentsDate: string;
  startTime: string;
  endTime: string;
  companion: number;
  lastName: string;
  firstName: string;
  visitorSei: string;
  visitorMei: string;
  birthday: string;
  sex: string;
  emailUsername: string;
  emailDomain: string;
  telephone: string;
  isChecked: boolean;
  contentsName: string;
  shopName: string;
  eqsName: string;
  spaceName: string;
  isAnnex: boolean;
  clubAddress: string;
};

export type PostVisitorRegister = {
  isLoading: boolean;
  isLoaded: boolean;
  result: number;
  message: string | null;
  visitorId: string | null;
};

export type VisitorBlackListCheckResult = {
  isLoading: boolean;
  isLoaded: boolean;
  result: number;
  message: string | null;
};

export type VisitorRegisterConfirmType = {
  visitorRegisterConfirm: VisitorInfo;
  visitorRegisterPost: PostVisitorRegister;
  visitorBlackListCheckResult: VisitorBlackListCheckResult;
};

const initialState: VisitorRegisterConfirmType = {
  visitorRegisterConfirm: {
    contentsId: 0,
    eqsId: 0,
    contentsDate: '',
    startTime: '',
    endTime: '',
    companion: 0,
    lastName: '',
    firstName: '',
    visitorSei: '',
    visitorMei: '',
    birthday: '',
    sex: '1',
    emailUsername: '',
    emailDomain: '',
    telephone: '',
    isChecked: false,
    contentsName: '',
    shopName: '',
    eqsName: '',
    spaceName: '',
    isAnnex: false,
    clubAddress: '',
  },
  visitorRegisterPost: {
    isLoading: false,
    isLoaded: false,
    result: 0,
    message: null,
    visitorId: null,
  },
  visitorBlackListCheckResult: {
    isLoading: false,
    isLoaded: false,
    result: 0,
    message: null,
  },
};

const visitorRegisterConfirmReducer = (state = initialState, action: AnyAction): VisitorRegisterConfirmType => {
  return produce(state, (draft) => {
    const dataState = draft;
    switch (action.type) {
      case VISITOR_REGISTER_CONFIRM_DISPATCH:
        dataState.visitorRegisterConfirm = action.visitorInfo;
        break;
      case VISITOR_REGISTER_CONFIRM_DISPATCH_INIT:
        dataState.visitorRegisterConfirm = initialState.visitorRegisterConfirm;
        break;
      case POST_VISITOR_REGISTER_REQUEST:
        dataState.visitorRegisterPost.isLoading = true;
        dataState.visitorRegisterPost.isLoaded = false;
        dataState.visitorRegisterPost.result = 0;
        dataState.visitorRegisterPost.message = null;
        dataState.visitorRegisterPost.visitorId = null;
        break;
      case POST_VISITOR_REGISTER_SUCCESS:
        dataState.visitorRegisterPost.isLoading = false;
        dataState.visitorRegisterPost.isLoaded = true;
        dataState.visitorRegisterPost.result = action.res.result;
        dataState.visitorRegisterPost.message = action.res.errorMessage || null;
        dataState.visitorRegisterPost.visitorId = action.res.visitorId || null;
        break;
      case POST_VISITOR_REGISTER_FAILURE:
        dataState.visitorRegisterPost.isLoading = false;
        dataState.visitorRegisterPost.isLoaded = false;
        dataState.visitorRegisterPost.result = initialState.visitorRegisterPost.result;
        dataState.visitorRegisterPost.message = initialState.visitorRegisterPost.message;
        dataState.visitorRegisterPost.visitorId = initialState.visitorRegisterPost.visitorId;
        break;
      case POST_VISITOR_REGISTER_INITIAL:
        dataState.visitorRegisterPost.isLoading = false;
        dataState.visitorRegisterPost.isLoaded = false;
        dataState.visitorRegisterPost.result = initialState.visitorRegisterPost.result;
        dataState.visitorRegisterPost.message = initialState.visitorRegisterPost.message;
        dataState.visitorRegisterPost.visitorId = initialState.visitorRegisterPost.visitorId;
        break;
      case GET_VISITOR_RESERVATION_CHECK_REQUEST:
        dataState.visitorBlackListCheckResult.isLoading = true;
        dataState.visitorBlackListCheckResult.isLoaded = false;
        dataState.visitorBlackListCheckResult.result = 0;
        dataState.visitorBlackListCheckResult.message = null;
        break;
      case GET_VISITOR_RESERVATION_CHECK_SUCCESS:
        dataState.visitorBlackListCheckResult.isLoading = false;
        dataState.visitorBlackListCheckResult.isLoaded = true;
        dataState.visitorBlackListCheckResult.result = action.res.result;
        dataState.visitorBlackListCheckResult.message = action.res.message || null;
        break;
      case GET_VISITOR_RESERVATION_CHECK_FAILURE:
        dataState.visitorBlackListCheckResult.isLoading = false;
        dataState.visitorBlackListCheckResult.isLoaded = false;
        dataState.visitorBlackListCheckResult.result = initialState.visitorBlackListCheckResult.result;
        dataState.visitorBlackListCheckResult.message = initialState.visitorBlackListCheckResult.message;
        break;
      case GET_VISITOR_RESERVATION_CHECK_INITIAL:
        dataState.visitorBlackListCheckResult.isLoading = false;
        dataState.visitorBlackListCheckResult.isLoaded = false;
        dataState.visitorBlackListCheckResult.result = initialState.visitorBlackListCheckResult.result;
        dataState.visitorBlackListCheckResult.message = initialState.visitorBlackListCheckResult.message;
        break;
      case VISITOR_COMPLETE_DISPATCH:
        dataState.visitorRegisterConfirm = action.visitorInfo;
        break;
      case VISITOR_COMPLETE_DISPATCH_INIT:
        dataState.visitorRegisterConfirm = initialState.visitorRegisterConfirm;
        break;
      default:
        break;
    }
  });
};

export default visitorRegisterConfirmReducer;
